"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailCustomerResetPassword = void 0;
const React = require("react");
const react_1 = require("react");
const Form_1 = require("../../../../../components/base/forms/Form");
const Message_1 = require("../../../../../components/base/atoms/Message");
const SlimSection_1 = require("../../../../../components/base/structure/SlimSection");
const useClient_1 = require("../../../../../hooks/useClient");
const text_1 = require("../helpers/text");
const formSchema = [
    {
        type: "passwordConfirm",
        required: true,
        label: "Password & Confirm",
        map: "newPassword",
        requiredMessage: "^Your passwords must match",
        remoteCheck: "{servicesUrl}retailCustomers/check-password-strength",
        remoteMessage: text_1.passwordStrengthErrorMsg,
        showStrength: true
    }
];
const RetailCustomerResetPassword = ({ token }) => {
    const client = (0, useClient_1.useClient)();
    const [success, setSuccess] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)("");
    const onSuccessHandler = (0, react_1.useCallback)(async (data) => {
        const { newPassword } = data;
        // clear error messages
        setError("");
        return client.retailCustomers
            .resetPassword(token, newPassword)
            .then(() => {
            setSuccess(true);
        })
            .catch(e => {
            console.error(e);
            setError("Unable to reset your password. It looks like something went wrong. Please try again.");
        });
    }, []);
    return (React.createElement(SlimSection_1.SlimSection, null,
        React.createElement(SlimSection_1.SlimSectionHeader, null,
            React.createElement(SlimSection_1.SlimSectionTitle, null, "Reset your password")),
        React.createElement(SlimSection_1.SlimSectionBody, null,
            !success && (React.createElement(Form_1.Form, { schema: formSchema, onSuccess: data => {
                    onSuccessHandler(data);
                }, disableOnSuccess: false, submitLabel: "Reset password" })),
            success && (React.createElement(Message_1.Message, null,
                React.createElement(Message_1.MessageTitle, null, "Your password has been reset successfully."))),
            error && (React.createElement(Message_1.ErrorMessage, null,
                React.createElement(Message_1.MessageTitle, null, error))))));
};
exports.RetailCustomerResetPassword = RetailCustomerResetPassword;
//# sourceMappingURL=index.js.map